module.exports = __webpack_public_path__ + "static/img/filter-inactive.5d2ab6b.svg";